type PopularSearchesResponse = {
  meta: {
    page: {
      size: number;
      current: number;
    };
  };
  results: Array<{
    term: string;
    clicks: number;
    queries: number;
  }>;
};

export const getPopularSearches = async (): Promise<Array<string>> => {
  const response = await fetch(
    `${process.env.GATSBY_ELASTICSEARCH_URL}/api/as/v1/engines/${process.env.GATSBY_ELASTICSEARCH_ENGINE}/analytics/queries`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // FIXME: search key doesn't work, find a solution
        Authorization: `Bearer ${process.env.GATSBY_ELASTICSEARCH_SEARCH_KEY}`,
      },
      body: JSON.stringify({
        page: {
          size: 3,
        },
        filters: {
          results: true,
        },
      }),
    }
  );

  try {
    const parsedResponse: PopularSearchesResponse = await response.json();

    return parsedResponse.results.map(({ term }) => term);
  } catch {
    return [];
  }
};
